import React, { ChangeEvent } from 'react';
import { Box, Text, Stack, Checkbox } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { SearchAndSortTypes } from '../filters/seekersFiltersContextValueType';
import { useSeekersFilters } from '../filters/SeekersFiltersContext';
import { SearchAndSortProps } from './searchAndSortType';

export const BackgroundCheck = ({ tempSearchAndSortType, setTempSearchAndSortTypes }: SearchAndSortProps): JSX.Element => {
  const { t } = useTranslation();

  const { setIsFromSearchAndSort } = useSeekersFilters();

  const onHandleBackgroundCheck = (searchAndSort: SearchAndSortTypes) => {
    setIsFromSearchAndSort(true);
    setTempSearchAndSortTypes({ ...searchAndSort });
  };

  return (
    <Box>
      <Stack direction="column">
        <Checkbox
          data-testid="completedCheckBox"
          isChecked={tempSearchAndSortType.backgroundCheck.includes('COMPLETE')}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            if (e.target.checked) {
              tempSearchAndSortType.backgroundCheck.push('COMPLETE');
            } else {
              const index = tempSearchAndSortType.backgroundCheck.indexOf('COMPLETE');
              tempSearchAndSortType.backgroundCheck.splice(index, 1);
            }
            onHandleBackgroundCheck(tempSearchAndSortType);
          }}
        >
          <Text
            px={3}
            style={{
              fontSize: '14px',
              fontWeight: 'normal',
            }}
          >
            {t('backgroundCheck.done')}
          </Text>
        </Checkbox>
        <Checkbox
          data-testid="sentCheckBox"
          isChecked={tempSearchAndSortType.backgroundCheck.includes('SENT')}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            if (e.target.checked) {
              tempSearchAndSortType.backgroundCheck.push('SENT');
            } else {
              const index = tempSearchAndSortType.backgroundCheck.indexOf('SENT');
              tempSearchAndSortType.backgroundCheck.splice(index, 1);
            }
            onHandleBackgroundCheck(tempSearchAndSortType);
          }}
        >
          <Text
            px={3}
            style={{
              fontSize: '14px',
              fontWeight: 'normal',
            }}
          >
            {t('backgroundCheck.Sent')}
          </Text>
        </Checkbox>
        <Checkbox
          data-testid="inprogressCheckBox"
          isChecked={tempSearchAndSortType.backgroundCheck.includes('IN_PROGRESS')}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            if (e.target.checked) {
              tempSearchAndSortType.backgroundCheck.push('IN_PROGRESS');
            } else {
              const index = tempSearchAndSortType.backgroundCheck.indexOf('IN_PROGRESS');
              tempSearchAndSortType.backgroundCheck.splice(index, 1);
            }
            onHandleBackgroundCheck(tempSearchAndSortType);
          }}
        >
          <Text
            px={3}
            style={{
              fontSize: '14px',
              fontWeight: 'normal',
            }}
          >
            {t('backgroundCheck.IN_PROGRESS')}
          </Text>
        </Checkbox>
        <Checkbox
          data-testid="partialCheckBox"
          isChecked={tempSearchAndSortType.backgroundCheck.includes('PARTIAL')}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            if (e.target.checked) {
              tempSearchAndSortType.backgroundCheck.push('PARTIAL');
            } else {
              const index = tempSearchAndSortType.backgroundCheck.indexOf('PARTIAL');
              tempSearchAndSortType.backgroundCheck.splice(index, 1);
            }
            onHandleBackgroundCheck(tempSearchAndSortType);
          }}
        >
          <Text
            px={3}
            style={{
              fontSize: '14px',
              fontWeight: 'normal',
            }}
          >
            {t('backgroundCheck.partiallyDone')}
          </Text>
        </Checkbox>
        <Checkbox
          data-testid="disputeCheckbox"
          isChecked={tempSearchAndSortType.backgroundCheck.includes('DISPUTE')}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            if (e.target.checked) {
              tempSearchAndSortType.backgroundCheck.push('DISPUTE');
            } else {
              const index = tempSearchAndSortType.backgroundCheck.indexOf('DISPUTE');
              tempSearchAndSortType.backgroundCheck.splice(index, 1);
            }
            onHandleBackgroundCheck(tempSearchAndSortType);
          }}
        >
          <Text
            px={3}
            style={{
              fontSize: '14px',
              fontWeight: 'normal',
            }}
          >
            {t('backgroundCheck.DISPUTE')}
          </Text>
        </Checkbox>
        <Checkbox
          data-testid="noneCheckbox"
          isChecked={tempSearchAndSortType.backgroundCheck.includes('NONE')}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            if (e.target.checked) {
              tempSearchAndSortType.backgroundCheck.push('NONE');
            } else {
              const index = tempSearchAndSortType.backgroundCheck.indexOf('NONE');
              tempSearchAndSortType.backgroundCheck.splice(index, 1);
            }
            onHandleBackgroundCheck(tempSearchAndSortType);
          }}
        >
          <Text
            px={3}
            style={{
              fontSize: '14px',
              fontWeight: 'normal',
            }}
          >
            {t('backgroundCheck.notDone')}
          </Text>
        </Checkbox>
      </Stack>
    </Box>
  );
};
